


<div class="dialog-content-wrapper">
    <mat-toolbar class="color-green m-0">
        <mat-toolbar-row fxFlex fxLayout="row" [fxLayoutAlign]="closed ? 'space-between center' : 'center center'">
            <span class="title dialog-title">{{title}}</span>
            <button *ngIf="closed" mat-icon-button (click)="dialogRef.close(false)" aria-label="Close dialog">
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="p-16 pb-0 m-0" fusePerfectScrollbar>
        <mat-card class="primary-A100"> <!-- style=" margin: auto; margin-bottom: 10px !important; align-items: center;" -->

            <mat-card-content> 

                <div fxLayout="column" fxLayoutAlign="start center" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="center center">
                    <mat-label style="text-align: center;">
                        
                        <h2><b>{{aviso}}</b></h2>                                                                                
                        
                    </mat-label>                                  
                </div>

                <div *ngFor="let item of arrayMessage"  fxLayout="column" fxLayoutAlign="center center" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="center center">
                    <mat-label style="text-align: center;" *ngIf="permiteEstoque == true && msgEstoque == 'Estoque'">
                        
                        <b><p>{{item}}</p></b>
                                                                                
                    </mat-label>                                  
                </div>
                                        
            </mat-card-content>           
                
        </mat-card>

        <div style="margin: 10px;" fxLayout="column" [fxLayoutAlign]="alignButton ? 'center center' : 'end end'" fxLayout.gt-sm="row">
            <button mat-raised-button class="color-green mr-16" (click)="comfirm()">OK</button>               
        </div> 

    </div>
    
</div>
